import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import classes from 'components/common/Tables/Cells/ValidationNameCell/ValidationNameCell.module.scss';
import { Pills } from 'components/common/pills/pills';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { DEFAULT_QUALITY_CATEGORY } from 'components/widgets/LogicQualityCategoriesTable/LogicQualityCategoriesTable';

export const ValidationNameCell = ({ value, safeValue, isDCMA, category, versionHashCode }) => {
    const fullPath = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_PLANNING_PATH,
        riskConfig.logicQualityCheck.link,
        versionHashCode,
        DEFAULT_QUALITY_CATEGORY,
        safeValue,
    );
    const relativePath = `${category}/${safeValue}`;
    // If versionHashCode exists create full path link, used in report for full reroute
    const path = versionHashCode ? fullPath : relativePath;

    return (
        <div className={classes.container}>
            <div>
                <Link className={classes.link} to={path}>
                    {value}
                </Link>
            </div>
            {isDCMA && (
                <div>
                    <Pills type={'tag'}>DCMA</Pills>
                </div>
            )}
        </div>
    );
};
